import { SlideContent, PromotionContent, TakeActionContent } from '../types';

export function getCategoryFromContent(
  slide: SlideContent | PromotionContent | TakeActionContent
): string {
  // For TakeActionContent and SlideContent with chid
  if (slide.chid?.startsWith('TA')) return 'take-actions';

  // For SlideContent (top-level category)
  if ('category' in slide && typeof slide.category === 'string') {
    const cat = slide.category.toLowerCase();
    if (cat === 'programme') return 'programme';
    if (cat === 'masterclass') return 'masterclass';
  }

  // For PromotionContent (category inside media)
  if ('media' in slide && slide.media && typeof slide.media.category === 'string') {
    const cat = slide.media.category.toLowerCase();
    if (cat === 'programme') return 'programme';
    if (cat === 'masterclass') return 'masterclass';
  }

  return 'media';
}
